import { requireTranslations } from '../../../common/translation';

export default requireTranslations((locale: string) => require(`./featured-banner.${locale}.json`));
